// extracted by mini-css-extract-plugin
export default {"root":"login_root__h68iD","typography":"login_typography__AJojb","logo":"login_logo__S2bIa"};